import React from 'react';
import { useState } from 'react';
import { createUseStyles } from 'react-jss';
import SecondaryHotspot from './hotspot/SecondaryHotspot';
import Panorama from './Panorama';
import PrimaryWrapper from './primaries/PrimaryWrapper';
import variables from '../theme/variables';
import About from './aboutPage/About';
import { PreloadProvider } from './primaries/Preloader';

const useStyles = createUseStyles(
    {
        wrap: {
            position: 'relative',
            width: '100%',
            minHeight: 'var(--app-height)',
            top: 0,
            left: 0,
            backgroundColor: 'red',
        },

        aboutButtonWrap: {
            position: 'fixed',
            top: `${variables.msftHeaderHeightMobile + 36}px`,
            left: 14,
            // zIndex: 100,

            '@media (min-width: 860px)': {
                top: `${variables.msftHeaderHeight + 46}px`,
                left: 60,
            },
        },

        aboutButton: {
            color: variables.palette.white,
            fontSize: 18,
            textDecoration: 'underline',
            textUnderlineOffset: '0.25em',
        },
    },
    { name: 'Studio' }
);

export default function Studio() {
    const classes = useStyles();

    const [activeSecondary, setActiveSecondary] = useState(null);
    const [activePrimary, setActivePrimary] = useState(null);
    const [aboutVisible, setAboutVisible] = useState(false);

    const handleHotspotClick = (hotspot) => {
        setActiveSecondary(hotspot);
    };

    const handlePrimaryClick = (hotspot) => {
        setActivePrimary(hotspot);
    };

    const openAbout = () => {
        setAboutVisible(true);
    };

    return (
        <PreloadProvider>
            <div className={classes.wrap}>
                <Panorama
                    onHotspotClick={handleHotspotClick}
                    onPrimaryClick={handlePrimaryClick}
                />

                <div className={classes.aboutButtonWrap}>
                    <button
                        className={classes.aboutButton}
                        onClick={() => setAboutVisible(true)}
                    >
                        Sol LeWitt x Microsoft
                    </button>
                </div>

                {aboutVisible && (
                    <About onClose={() => setAboutVisible(false)} />
                )}

                {!!activeSecondary && (
                    <SecondaryHotspot
                        hotspot={activeSecondary}
                        onClose={() => setActiveSecondary(null)}
                    />
                )}

                {!!activePrimary && (
                    <>
                        {activePrimary.id === 'splotchRenderings' ? (
                            <PrimaryWrapper
                                data={activePrimary}
                                onClose={() => setActivePrimary(null)}
                            />
                        ) : (
                            <PrimaryWrapper
                                data={activePrimary}
                                onClose={() => setActivePrimary(null)}
                            />
                        )}
                    </>
                )}
            </div>
        </PreloadProvider>
    );
}
